module.exports = __webpack_public_path__ + "static/media/21ECLAC28.3c45bc33.jpg";